import React from 'react';
import request, { METHODS } from '@/api'
import { useEffect, useState } from 'react'
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components'
import {Form, Input, Select, message, DatePicker, InputNumber} from 'antd';
import dayjs from 'dayjs';
import {
  subscribeArrive,
  appointmentTypeEnum,
  functionNeedEnum,
  getHouseNatureEnum,
  getHouseTypeEnum,
  getHouseDecorateStyleEnum,
  getBudGetEnums, getProductionTypeEnum, getAppointmentList
} from '@/services/customerServices';
import styles from './index.module.less'
import {trimStr} from "@/utils/data.ts";
import {clueAppointment} from "@/services/callCenter";
import {isArray, isEmpty} from "lodash-es";

const TextArea = Input.TextArea;

export default function SubscribeModal ({
  editId = '',
  open = false,
  buttonKey = '',
  basicInfo = {},
  onClose = () => {},
  reload = () => {},
})  {
  const [ form ] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if(!isEmpty(basicInfo)) {
      console.log(basicInfo.dtlInfo)
      form.setFieldsValue({
        doorNo: (basicInfo as any)?.houseInfo?.doorNo,
        houseNatureCode: (basicInfo as any)?.houseInfo?.houseNatureCode,
        handoverDate: (basicInfo as any)?.houseInfo?.handoverDate ? dayjs(basicInfo?.houseInfo?.handoverDate) : '',
        layout: (basicInfo as any)?.houseInfo?.layout,
        innerArea: (basicInfo as any)?.houseInfo?.innerArea,
        designStyleCode: (basicInfo as any)?.dtlInfo?.designStyleCode,
        intentionProductCode: (basicInfo as any)?.dtlInfo?.intentionProductCode,
        budget: (basicInfo as any)?.dtlInfo?.budget,
        houseDemand: (basicInfo as any)?.dtlInfo?.houseDemand,
      })
    }
    fetchDictionaryData();
    fetchAppointmentList();
  }, [basicInfo]);

  const fetchAppointmentList = ()=>{
    getAppointmentList({
      clueId: editId,
      isArrived:false
    }).then((res)=>{
      if(isArray(res)&&res.length>0){
        const obj = res[0];
        form.setFieldsValue({
          appointmentType: obj?.appointmentType||"",
          appointmentDate: obj?.appointmentDate? dayjs(obj?.appointmentDate) : '',
        })
      }
    })
  }
  const fetchDictionaryData = async () => {
    try {
      setLoading(true)
      const resList: any = await Promise.allSettled([
        appointmentTypeEnum(),
        functionNeedEnum(),
        getHouseNatureEnum(),
        getHouseTypeEnum(),
        getHouseDecorateStyleEnum(),
        getBudGetEnums(),
        getProductionTypeEnum(),
      ]);
      const map = {
        appointmentType: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
        houseDemand: resList?.[1]?.value instanceof Array ? resList?.[1]?.value : [],
        houseNatureCode: resList?.[2]?.value instanceof Array ? resList?.[2]?.value : [],
        layout: resList?.[3]?.value instanceof Array ? resList?.[3]?.value : [],
        designStyleCode: resList?.[4]?.value instanceof Array ? resList?.[4]?.value : [],
        budget: resList?.[5]?.value instanceof Array ? resList?.[5]?.value : [],
        intentionProductEnum: resList?.[6]?.value instanceof Array ? resList?.[6]?.value : [],
      }
      setDictionaryData(map);
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
        setLoading(true);
        const values_ = {
          ...values,
          appointmentDate: values.appointmentDate ? dayjs(values.appointmentDate).format('YYYY-MM-DD HH:mm:ss') : '',
          handoverDate: values.handoverDate ? dayjs(values.handoverDate).format('YYYY-MM-DD') : '',
          clueId: editId, buttonKey,
        }
        clueAppointment(values_)
            .then(res => {
              message.success(res.message || '预约见面成功');
              onClose();
              reload();
            }).finally(() => setLoading(false))
    })
  }

  const range = (start: number, end: number) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };
  const disabledDateTime = (data: any) => {
    const _hours = dayjs().hour()
    const isToday = dayjs(data).isSame(dayjs(), 'day')
    const disabledHours = range(0, 60).splice(0, _hours+1)
    return {
      disabledHours: () => (!isToday && data)? [] :disabledHours,
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    }
  }

  return (
    <div className={styles.subscribeModal}>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        width={500}
        title="预约见面"
      >
        <Form
          form={form}
          labelCol={{
            span: 8,
          }}
          name="basicInfo"
          layout="vertical"
        >
          <Form.Item
            name="appointmentType"
            label="见面类型"
            rules={[
              {
                required: true,
                message: '请选择见面类型',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择见面类型'} fieldNames={{label: 'description', value: 'key' }}  options={dictionaryData['appointmentType']} />
          </Form.Item>
          <Form.Item
            name="appointmentDate"
            label="预约见面时间"
            rules={[
              {
                required: true,
                message: '请选择预约见面时间',
              },
            ]}
          >
            <DatePicker
                format="YYYY-MM-DD HH:00"
                showTime={{format: 'YYYY-MM-DD HH:00'}}
                style={{ width: '100%' }}
                disabledDate={current => { return current && current < dayjs().subtract(1, 'day')}}
                disabledTime={disabledDateTime}
            />
          </Form.Item>
          {/*<Form.Item
            name="handoverDate"
            label="交房日期"
            rules={[
              {
                required: true,
                message: '请选择交房日期',
              },
            ]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>*/}
          <Form.Item
            name="houseNatureCode"
            label="房屋属性"
            rules={[
              {
                required: true,
                message: '请填写房屋属性',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请填写房屋属性'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['houseNatureCode']} />
          </Form.Item>
          <Form.Item
            name="doorNo"
            label="门牌号"
            // rules={[
            //   {
            //     required: true,
            //     message: '请填写门牌号',
            //   },
            // ]}
            style={{
              width: '100%'
            }}
          >
            <Input placeholder={'请填写门牌号'} maxLength={20} onChange={(e) => form.setFieldValue('doorNo', trimStr(e.target.value))}/>
          </Form.Item>
          <Form.Item
            name="layout"
            label="户型"
            rules={[
              {
                required: true,
                message: '请选择户型',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择户型'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['layout']} />
          </Form.Item>
          <Form.Item
            name="innerArea"
            label="套内面积"
            rules={[
              {
                required: true,
                message: '请填写套内面积',
              },
            ]}
          >
            <InputNumber style={{width: '100%'}} placeholder={'请输入套内面积'} precision={2} min={0} max={999999999}/>
          </Form.Item>
          <Form.Item
            name="houseDemand"
            label="功能需求"
            rules={[
              {
                required: true,
                message: '请选择功能需求',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择功能需求'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['houseDemand']} />
          </Form.Item>
          <Form.Item
            name="designStyleCode"
            label="装修风格"
            rules={[
              {
                required: true,
                message: '请选择装修风格',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择装修风格'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['designStyleCode']} />
          </Form.Item>
          <Form.Item
            name="budget"
            label="预算"
            rules={[
              {
                required: true,
                message: '请选择预算',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择预算'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['budget']} />
          </Form.Item>
          <Form.Item
            name="intentionProductCode"
            label="产品意向"
            // rules={[
            //   {
            //     required: true,
            //     message: '请选择产品意向',
            //   },
            // ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择产品意向'} fieldNames={{label: 'description', value: 'key' }} options={dictionaryData['intentionProductEnum']} />
          </Form.Item>
          <Form.Item
            name="remark"
            label="备注"
            style={{
              width: '100%'
            }}
          >
            <TextArea placeholder={'请填写备注'} rows={3} maxLength={200} showCount
                      onChange={(e) => form.setFieldValue('remark', trimStr(e.target.value))} />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
